// extracted by mini-css-extract-plugin
export var blockBtn = "main-module--block-btn--b1eac";
export var blockTitle = "main-module--block-title--8466d";
export var blockTitleLg = "main-module--block-title-lg--6dc2d";
export var blockTitleMd = "main-module--block-title-md--96c29";
export var blockTitleSm = "main-module--block-title-sm--8745f";
export var col = "main-module--col--8452d";
export var col1 = "main-module--col1--d94db";
export var courseBlock = "main-module--course-block--868ca";
export var purple = "main-module--purple--844c3";
export var red = "main-module--red--60914";
export var rowNoMrg = "main-module--row-no-mrg--e1eaf";
export var sec = "main-module--sec--e2da5";
export var title_h1 = "main-module--title_h1--227e9";